import React from "react";
import "./Trygghet.css";
import CodeHideOurSolution from "../../assets/ttgimage3.jpg";

function Trygghet() {
  return (
    <div className="ttg-two-container">
      <div className="ttg-two-content">
        <div className="ttg-two-text-container">
          <h1 className="ttg-two-main-title">
            Bygg med Trygghet och Tillit
          </h1>

          <p className="ttg-two-description-12">
            Hos Tak Till Golv är vi dedikerade till att förverkliga era
            byggdrömmar med högsta standard av säkerhet och kvalitet. Vi förstår
            att ert hem är er fristad och att varje projekt är en möjlighet att
            förbättra både funktionalitet och skönhet. Med vår expertis och
            erfarenhet vid rodret kan ni känna er trygga i att ert projekt
            kommer att utföras med precision och omsorg.
            <br></br>
            <br></br>
            Vi strävar alltid efter att överträffa era förväntningar genom att
            erbjuda skräddarsydda lösningar som passar era unika behov och
            önskemål. Oavsett om ni planerar en omfattande renovering eller en
            mindre uppgradering, kan ni lita på oss för att leverera resultat av
            högsta kvalitet, varje gång.
            <br></br>
            <br></br>
            Med vårt breda utbud av tjänster, inklusive totalentreprenad,
            målning, golvläggning, takarbeten, epoxigolv, kakelarbete, köks- och
            badrumsrenoveringar, VVS- och elinstallationer och mycket mer, är vi
            er pålitliga partner för alla era byggbehov. Låt oss hjälpa er att
            skapa det hem ni alltid har drömt om, med säkerhet och kvalitet i
            fokus.
          </p>
        </div>

        <div className="ttg-two-Our-Solution-container">
          <img
            src={CodeHideOurSolution}
            alt="CodeHideOurSolution"
            className="ttg-two-Our-Solution"
          />
        </div>
      </div>
    </div>
  );
}

export default Trygghet;
